// extracted by mini-css-extract-plugin
var _1 = "YOzGF";
var _2 = "M6KgV";
var _3 = "uQgCn";
export { _1 as "debugSwitch", _2 as "debugSwitchButton", _3 as "debugSwitchButtonSelected" }
